module.exports = __webpack_public_path__ + "img/default.d4e6e1b6.png";